import React from 'react';
import PropTypes from 'prop-types';

import { TableCell as MuiTableCell } from '@material-ui/core';

const TableCell = ({ children, ...rest }) => {
  return (
    <MuiTableCell
      {...rest}
    >
      { children }
    </MuiTableCell>
  )
}

TableCell.defaultProps = {
  children: null,
};

TableCell.propTypes = {
  children: PropTypes.node,
};

export default TableCell;



// WEBPACK FOOTER //
// ./src/components/base/TableCell/TableCell.js